// Self-contained data for the Judy M. Cabrera Accounting Services concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/11_Judy_M_Cabrera_Accounting_Services
// (research snapshot 2026-08-21). PRC records show public-accountancy accreditation No. 7613 was
// valid Nov 20 2023–Nov 30 2025 — current 2026 renewal is NOT independently confirmed, so this is
// presented as accreditation on record rather than a current-BOA-accredited claim.
export const BIZ = {
  name: "Judy M. Cabrera Accounting Services",
  principal: "Judy Montano-Cabrera, CPA",
  tagline: "Accounting, Tax & Business Registration Support for Naic, Cavite",
  address: "Unit J, Francis & Paul Commercial 12, Captain Ciriaco Nazareno St., Naic, Cavite 4110",
  phone: "+63464142300",
  phoneDisplay: "(046) 414-2300",
  mobile: "+639651458012",
  mobileDisplay: "+63 965 145 8012",
  facebook: "https://www.facebook.com/101570914584170",
  linkedin: "https://ph.linkedin.com/in/judy-montano-cabrera-2aabaa28",
  mapEmbed: "https://www.google.com/maps?q=Francis+and+Paul+Commercial+Naic+Cavite&output=embed",
};

export const SERVICES = [
  { title: "Business Registration", text: "End-to-end support registering a new business." },
  { title: "Bookkeeping & Compilation", text: "Ongoing bookkeeping and compilation services." },
  { title: "Tax Consultancy & Filing", text: "Tax consultancy and tax-return filing." },
  { title: "Payroll", text: "Payroll processing support." },
  { title: "Business Consultation", text: "General business consultation." },
  { title: "Land Title Transfer", text: "Transfer of land titles." },
  { title: "Audit / Attestation", text: "Audit and attestation services." },
];

export const ABOUT = {
  credential: "PRC public-accountancy accreditation on record (No. 7613, valid Nov 20, 2023 – Nov 30, 2025) — confirm current renewal status directly.",
  background: "I've operated my accounting practice since at least 2018, with earlier internal-audit experience. I studied at the University of Perpetual Help System DALTA and hold a Diploma in International Financial Reporting Standards.",
  community: "I've conducted business-registration information sessions in partnership with the Municipality of Naic.",
};

export const REPUTATION = {
  rating: "5.0",
  note: "Rating shown in current local-directory listings. Individual review text was not recoverable — recheck the exact current count before publishing.",
};
